import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { Loader, EmptyState, StatusBadge, Money } from "@/components/shared";
import { Wallet } from "lucide-react";

export default function Settlements() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/manufacturer/settlements").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items) return <Loader />;

  const pending = items.filter((s) => s.status !== "SETTLED").reduce((a, s) => a + s.amount, 0);
  const settled = items.filter((s) => s.status === "SETTLED").reduce((a, s) => a + s.amount, 0);

  return (
    <div className="space-y-5">
      <h1 className="font-heading text-2xl font-semibold text-forest">Settlements</h1>
      <div className="grid grid-cols-2 gap-4 lg:w-1/2">
        <div className="rounded-xl border border-border bg-card p-5"><span className="overline text-olive">Pending</span><div className="num mt-1 text-2xl font-semibold text-forest">{money(pending)}</div></div>
        <div className="rounded-xl border border-border bg-card p-5"><span className="overline text-olive">Settled</span><div className="num mt-1 text-2xl font-semibold text-forest">{money(settled)}</div></div>
      </div>
      {items.length === 0 ? <EmptyState title="No settlements yet" hint="Settlements are recorded after orders are paid and fulfilled." icon={Wallet} /> : (
        <div className="overflow-hidden rounded-xl border border-border bg-card">
          <table className="w-full text-sm">
            <thead className="bg-psage/40 text-left"><tr className="overline text-forest">
              <th className="px-4 py-3">Order</th><th className="px-4 py-3">Gross</th><th className="px-4 py-3">Commission</th>
              <th className="px-4 py-3">GST on fee</th><th className="px-4 py-3">Payout</th><th className="px-4 py-3">Status</th><th className="px-4 py-3">Ref</th>
            </tr></thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.id} data-testid={`settlement-${s.id}`} className="border-t border-border">
                  <td className="num px-4 py-3 font-medium text-forest">{s.order_number}</td>
                  <td className="num px-4 py-3">{money(s.gross)}</td>
                  <td className="num px-4 py-3 text-red-600">-{money(s.commission)}</td>
                  <td className="num px-4 py-3 text-red-600">-{money(s.commission_gst)}</td>
                  <td className="num px-4 py-3 font-semibold text-forest">{money(s.amount)}</td>
                  <td className="px-4 py-3"><StatusBadge status={s.status} /></td>
                  <td className="num px-4 py-3 text-ink/60">{s.bank_reference || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
